export const ru = {
    'buttons': {
        'return': 'Назад',
        'main': 'Главная'
    },
    'selects': {
        'currency': {
            'label': 'Валюта',
            'placeholder': 'Выберите валюту',
            'options-title': 'Доступные монеты'
        },
        'currency-and-network': {
            'placeholder': 'Выберите валюту и сеть',
            'options-title': 'Доступные монеты'
        },
        'selected-label': 'Выбрано {selected} из {length}',
        'search': 'Поиск',
        'errors': {
            'invalid': 'Некорректное значение',
            'required': 'Необходимо заполнить',
            'card-holder': 'Введите имя и фамилию держателя карты',
            'input-amount': "Введите сумму",
            'fill-card': "Заполните данные карты"
        },
        'empty-list': 'Список пуст',
        'address': {
            'label': 'Адрес для вывода {currency}',
            'options-title': 'Доступные адреса',
            'placeholder': 'Выберите адрес'
        },
        'cardholder-input': {
            'placeholder': 'Владелец карты',
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Ваш адрес для депозита'
            },
            'invoice': {
                'address': 'Адрес',
                'paid-amount': 'Оплаченная сумма',
                'amount-to-pay': 'Сумма к оплате'
            }
        }
    },
    'labels': {
        'deposit': 'Депозит',
        'withdraw': 'Вывод',
        'currency': 'Валюта',
        'amount': 'Сумма',
        'language': 'Язык',
        'russian': 'Русский',
        'english': 'Английский',
        'theme': 'Тема',
        'dark': 'Темная',
        'light': 'Светлая',
        'view': 'Смотреть',
        'cookie-policy': {
            'label': 'Политика cookie',
            'open-policy': 'Открыть политику'
        },
        'invoice': {
            'remaining-time': 'Оставшееся время для оплаты',
            'status': {
                'expires': 'Время вышло',
                'success': 'Успешная оплата',
                'error': 'Ошибка'
            },
            'partially-paid': {
                'title': 'Частично оплачено',
                'info': 'Сумма оплачена частично. Оставшаяся сумма должна быть внесена для успешной оплаты.'
            },
            'orphan': {
                'title': 'Потерянная транзакция',
                'description': 'В одной из транзакций этого ордера указана неправильная сеть или валюта.',
                'contact': 'Обратитесь в службу технической поддержки с ID',
            },
            'you-paid': 'Вы заплатили',
            'active-order': 'Активный ордер',
            'new-invoice': 'Новый счет',
            'order-id': 'Счет №',
            'payment-id': 'ID платежа',
            'description': 'Описание',
            'payment-amount': 'Сумма платежа',
            'rate': 'Курс обмена',
            'remaining-amount': 'Оставшаяся сумма к оплате'
        },
        'continue': 'Далее',
        'payout': {
            'address': 'Адрес для вывода в {currency}',
            'tag-or-memo': 'TAG или MEMO',
            'status': {
                'processed': 'Успех',
                'error': 'Ошибка',
                'orphan': 'Orphan transaction',
                'approve_rejected': 'Отклонено',
                'in-progress': 'В процессе',
                'need-approve': 'Требует подтверждения',
                'awaiting-confirmation': 'Ваш запрос на вывод ожидает подтверждения'
            },
            'info': {
                'withdraw-id': 'ID Вывода',
                'tx-hash': 'TX hash',
                'currency-and-network': 'Валюта и сеть',
                'address': 'Адрес',
                'tag-or-memo': 'TAG или MEMO',
                'amount': 'Сумма',
                'rate': 'Курс',
                'blockchain-fee': 'Комиссия сети'
            }
        },
        'fiat': {
            'title': 'Фиатный депозит',
            'info': {
                'amount': 'Сумма',
                'date': 'Дата платежа',
                'id': 'ID депозита',
                'system': 'Платежная система'
            },
            'status': {
                'new': 'В процессе',
                'pending': 'В процессе',
                'authorized': 'Успешно',
                'confirmed': 'Успешно',
                'reconciled': 'Успешно',
                'error': 'Ошибка',
                'declined': 'Отклонено'
            },
            'payment-id': 'ID платежа',
        },
        'information': 'Информация'
    },
    'errors': {
        'wrong-widget-id': 'Неправильный ID виджета',
        'wrong-ext-user-id': 'Неверный ID пользователя',
        '404': "Упс! Мы не нашли то, что вы ищете.",
        'without-xt-user-id-withdrawal': "Вывод недоступен. Параметр extUserId не передан",
        'without-xt-user-id-deposit': "Депозит недоступен. Параметр extUserId не передан",
        'amount': 'Сумма должна быть больше комиссии сети'
    },
    'invoice': {
        'order': 'Ордер',
        'inputs': {
            'email': {
                'label': 'E-mail адрес',
                'placeholder': 'Введите ваш e-mail адрес'
            },
            'amount': {
                'label': 'Сумма',
                'placeholder': 'Введите сумму'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Сумма в',
                'rate': 'Курс обмена',
                'payment-id': 'Платежный ID',
                'description': 'Описание'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'Не обновляйте страницу или откройте счет в',
            'new-tab': 'новой вкладке'
        },
        'statuses': {
            "ERROR": 'ОШИБКА',
            "PENDING": 'ОБРАБОТКА',
            "PROCESSED": 'ВЫПОЛНЕН',
            "REJECTED": 'ОТКЛОНЕН',
            'OVERPAID': 'ПЕРЕПЛАЧЕН',
            "CREATED": 'СОЗДАН',
            'PARTIAL': 'ЧАСТИЧНО ОПЛАЧЕН',
            'INIT': 'ИНИЦИИРОВАН',
            'EXPIRED': 'ИСТЕК'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Депозит',
            'payment-history': 'История',
            'payment-history-small': 'История платежей'
        },
        'payment-history': {
            'empty-label': 'Все ваши транзакции, отправленные на указанный адрес, будут доступны здесь',
            'headers': {
                'date': 'Дата и время',
                'amount': 'Сумма',
                'tx': 'Tx_hash',
                'status': 'Статус'
            },
            'statuses': {
                'orphan': 'Потерянная',
                'processed': 'Успешно',
                'pending': 'Обработка',
                'rejected': 'Отклонена',
                'error': 'Ошибка'
            },
            'in': 'в'
        },
        'qr-block': {
            'empty-label': 'Пополнение депозита криптовалютой',
            'qr-info-pre-invoice': 'Отправляйте только',
            'qr-info-pre-personal': 'Отправляйте любую сумму только в',
            'qr-info-post': 'на данный адрес',
            'qr-info-minimal': 'Переводы на сумму менее 1 USD не зачисляются'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Фиатный депозит',
            'payment-history': 'История платежей'
        },
        'labels': {
            'pay': 'Оплатить',
            'service-commission': 'Сумма комиссии сервиса',
            'total': 'Всего',
            'you-pay': 'Вы заплатите'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Потерянная транзакция',
            'info': 'В одной из транзакций этого ордера указана неправильная сеть или валюта.',
            'support': 'Обратитесь в службу технической поддержки с ID'
        }
    },
    'cookie-policy': {
        'by-clicking': 'Нажав на кнопку «Далее», вы автоматически соглашаетесь c',
        'our': 'нашей политикой использования файлов cookie'
    },
    'payout': {
        'payout': 'Выплата',
        'output': 'Вывод',
        'withdraw': 'Вывести',
        'errors': {
            'wrong-address': 'Адрес не в сети {network}'
        }
    }
}